import { useQuery } from '@tanstack/vue-query';
import { computed, ref } from 'vue';
import { getRole } from '@infuse/api/iam/role';
import { Role } from '@infuse/iam/role/type';

export const useRole = () => {
  const fetchRoleId = ref<string | undefined>(undefined);

  const query = useQuery<Role>({
    queryKey: ['roles', 'detail', fetchRoleId],
    enabled: () => !!fetchRoleId.value,
    queryFn: () => getRole({ id: fetchRoleId.value })
  });

  const role = computed(() => query.data.value);

  return {
    ...query,
    role,
    fetchRoleId
  };
};
